import { Component, OnInit, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgIf, NgTemplateOutlet } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-feature-item',
    templateUrl: './feature-item.component.html',
    styleUrls: ['./feature-item.component.scss'],
    standalone: true,
    imports: [MatIconModule, NgIf, NgTemplateOutlet, MatTooltipModule]
})
export class FeatureItemComponent implements OnInit {
    @Input() layout: 'compact' | 'full' | 'simplified' = 'full';
    @Input() icon: string;
    @Input() title: string;
    @Input() subtitle: string;

    constructor() { }

    ngOnInit(): void {
    }
}
